import { render, staticRenderFns } from "./Quantity.vue?vue&type=template&id=19cab0a0&scoped=true"
import script from "./Quantity.vue?vue&type=script&lang=ts"
export * from "./Quantity.vue?vue&type=script&lang=ts"
import style0 from "./Quantity.vue?vue&type=style&index=0&id=19cab0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cab0a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
